<template>
  <div :style="{ width, 'max-width': '100%' }">
    <label class="body-s-high">
      <InputLabel
        v-if="label"
        class="spc-mb-1"
        :info="info"
        :label="label"
        :required="required"
        :style="{ color: labelColor }"
      />
      <input
        :aria-describedby="ariaDescribedby"
        class="body-s-regular cr-br-small"
        :class="{
          'error': error,
          'hide-spinners': hideSpinners,
        }"
        :data-testid="`${id}_number_input`"
        :disabled="disabled"
        :placeholder="placeholder"
        :readonly="readOnly"
        :step="step"
        type="number"
        :value="value"
        @blur="$emit('blur', $event)"
        @input="$emit('update:value', $event.target.value)"
      >
    </label>
    <slot name="errors" />
  </div>
</template>

<script>
import InputLabel from './InputLabel.vue'

export default {
  name: 'NumberInput',
  components: {
    InputLabel,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    step: {
      type: String,
      default: '1',
    },
    required: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    hideSpinners: {
      type: Boolean,
      default: false,
    },
    ariaDescribedby: {
      type: String,
      default: null,
    },
    labelColor: {
      type: String,
      default: 'inherit',
    },
  },
  emits: ['update:value', 'blur'],
}
</script>

<style scoped lang="scss">
label, input {
  display: block;
  margin: 0;
}
input {
  width: 100%;
  padding: .65rem var(--space-2);
  border: 1px solid var(--pepper-300);
  outline: none;

  &:disabled {
    color: var(--pepper-600);
    background-color: var(--pepper-200);
  }

  &:focus {
    border-color: var(--blueberry-1000);
  }

  &::placeholder {
    color: var(--pepper-600);
  }

  &.error {
    border: 1px solid var(--chicago-dog-red-1000);
    &:focus-visible {
      outline: 2px solid var(--blueberry-300);
    }
  }
}

input.hide-spinners::-webkit-inner-spin-button,
input.hide-spinners::-webkit-outer-spin-button {
  display: none;
}

input.hide-spinners {
  appearance: textfield;  
  -moz-appearance: textfield;
}
</style>
